export function buildTree(data) {
    const root = [];
    const map = {};
    data.forEach(item => {
        map[item.id] = item;
        item.children = [];
    });
    data.forEach(item => {
        const {
            pid
        } = item;
        if (pid) {
            if (map[pid]) {
                map[pid].children.push(item);
            } else {
                console.error(`pid ${pid} not found`);
            }
        } else {
            root.push(item);
        }
    });
    return root;
}

export function menuConvert(data) {
    
    
    const children = menuConvert0(data).filter(o=>o.router=='后台菜单')[0].children
    children.forEach(item => {
        if(item.router=='离校设置'){
            item.children.push('材料认领管理-明细')
            item.children.push('毕业名单-明细')
        }
    })
    return [{
        router: 'root',
        children: [
            'home',
            // {
            //     router: 'dashboard',
            //     children: ['analysis'],
            // },
            ...children]
    }];
}

 function menuConvert0(data){
    return data.map(item => {
        return {
            router: item.menuName,
            children: item.menuList ? menuConvert0(item.menuList) : [],
        }
    })
}